module.exports = __webpack_public_path__ + "media/images/beauty/marie-claire@3x-96ff223ff644ca4e25caa76323da1b22.jpg";